import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useTranslations();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t('nav.requirements'),
    href: '#requirements'
  }, {
    name: t('nav.howItWorks'),
    href: '#how-it-works'
  }, {
    name: t('nav.aboutUs'),
    href: '#about'
  }, {
    name: t('nav.funding'),
    href: '#funding'
  }, {
    name: t('nav.testimonials'),
    href: '#testimonials'
  }, {
    name: t('nav.faq'),
    href: '#faq'
  }, {
    name: t('nav.contactUs'),
    href: '#contact'
  }];
  const scrollToSection = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsOpen(false);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm py-3' : 'bg-white py-4'}`} data-id="element-262">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263">
        <div className="flex items-center" data-id="element-264">
          {/* Logo - Left */}
          <div className="flex items-center cursor-pointer flex-shrink-0 mr-8" onClick={() => window.scrollTo(0, 0)} data-id="element-265">
            <img src="https://cdn.magicpatterns.com/uploads/fVUEiRadg8ns428LDaoR7Y/Asset_41x.png" alt="Brixen Funding" className="h-8 md:h-10 w-auto object-contain" style={{
            imageRendering: 'auto'
          }} data-id="element-266" />
          </div>

          {/* Desktop Nav Links */}
          <div className="hidden lg:flex items-center space-x-5 xl:space-x-7" data-id="element-267">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="text-[13px] font-medium text-gray-800 hover:text-[#00E676] transition-colors" data-id="element-268">
                {link.name}
              </button>)}
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-4 ml-auto" data-id="element-269">
            {/* Language Toggle */}
            <div className="flex items-center text-[13px] font-medium text-gray-500" data-id="element-270">
              <button onClick={() => setLang('en')} className={`transition-colors ${lang === 'en' ? 'text-gray-900 font-bold' : 'hover:text-gray-900'}`} data-id="element-271">
                EN
              </button>
              <span className="mx-1" data-id="element-272">|</span>
              <button onClick={() => setLang('es')} className={`transition-colors ${lang === 'es' ? 'text-gray-900 font-bold' : 'hover:text-gray-900'}`} data-id="element-273">
                ES
              </button>
            </div>

            <button onClick={() => scrollToSection('#contact')} className="inline-flex items-center justify-center text-[13px] font-bold px-4 py-2.5 rounded-lg text-[#00E676] border border-[#00E676] hover:bg-[#e6fcf0] transition-colors uppercase" data-id="element-274">
              {lang === 'es' ? 'AGENDAR CONSULTA' : 'SCHEDULE CONSULTATION'}
            </button>

            <a href="https://form.jotform.com/260402880146048" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-[13px] font-bold px-5 py-2.5 rounded-lg text-white bg-[#00E676] hover:bg-[#00d169] transition-colors uppercase animate-pulse" data-id="element-275">
              {lang === 'es' ? 'APLICAR AHORA' : 'APPLY NOW'}
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center ml-auto" data-id="element-276">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none" data-id="element-277">
              {isOpen ? <X className="h-6 w-6" data-id="element-278" /> : <Menu className="h-6 w-6" data-id="element-279" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-280">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-281">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="block w-full text-left px-3 py-3 text-sm font-medium text-gray-700 hover:text-[#00E676] hover:bg-gray-50 rounded-md" data-id="element-282">
                {link.name}
              </button>)}

            <div className="border-t border-gray-100 mt-2 pt-4 px-3 flex flex-col space-y-3" data-id="element-283">
              <div className="flex items-center justify-center gap-4 text-sm font-medium" data-id="element-284">
                <button onClick={() => setLang('en')} className={`px-3 py-1.5 rounded-full transition-colors ${lang === 'en' ? 'bg-gray-100 text-gray-900' : 'text-gray-500'}`} data-id="element-285">
                  English
                </button>
                <button onClick={() => setLang('es')} className={`px-3 py-1.5 rounded-full transition-colors ${lang === 'es' ? 'bg-gray-100 text-gray-900' : 'text-gray-500'}`} data-id="element-286">
                  Español
                </button>
              </div>

              <a href="https://form.jotform.com/260402880146048" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block w-full text-center text-sm font-bold px-6 py-3 rounded-lg text-white bg-[#00E676] hover:bg-[#00d169] transition-colors uppercase animate-pulse" data-id="element-287">
                {lang === 'es' ? 'APLICAR AHORA' : 'APPLY NOW'}
              </a>

              <button onClick={() => scrollToSection('#contact')} className="block w-full text-center text-sm font-bold px-6 py-3 rounded-lg text-[#00E676] border border-[#00E676] hover:bg-[#e6fcf0] transition-colors uppercase" data-id="element-288">
                {lang === 'es' ? 'AGENDAR CONSULTA' : 'SCHEDULE CONSULTATION'}
              </button>
            </div>
          </div>
        </div>}
    </nav>;
}